import './modal-confirmation-component.scss';
import { useEffect, useState, Fragment } from 'react';
import { useUserContext } from "../../userContext";
import { useNavigate } from 'react-router-dom';
import AlertDialogError from '../../pages/FrmSolicitud/AlertDialogError';
import { useSnackbar } from "../../hook/useSnackbar";
import { useZammadContext } from '../../context/ZammadContext';
import { useMsal } from "@azure/msal-react";
import FnSendRegisterZammad from '../../pages/FrmSolicitud/FnSendRegisterZammad';   


export default function ModalConfirmation({ setModalConfirmation, columnsFrm, dataFrm, infoFrm, sendRegister, fileUpload }) {

    
    const [openModalError, setOpenModalError] = useState(false);
    const { showSnackbar, SnackbarComponent } = useSnackbar();
    const [responseError, setResponseError] = useState({});

    const { startLoader, stopLoader } = useUserContext();
    const { zammadInstance, instanceReady } = useZammadContext();
    const { accounts } = useMsal();
    const navigate = useNavigate();

    const closeModalConfirm = () => {
        setModalConfirmation(false);
    }

    const sendDataConfirm = async () => {
        // Validar que zammadInstance esté inicializado
        if (!zammadInstance) {
            showSnackbar(
                'Error: La conexión con Zammad no está lista. Por favor, espere un momento e intente nuevamente.',
                "error"
            );
            return;
        }

        if (!accounts || accounts.length === 0) {
            showSnackbar(
                'Error: No se pudo obtener la información del usuario autenticado.',
                "error"
            );
            return;
        }

        startLoader();

        const userEmail = accounts[0].username;

        const result = await FnSendRegisterZammad(
            infoFrm,
            dataFrm,
            fileUpload,
            userEmail,
            zammadInstance
        );

        if (result.success) {
            setModalConfirmation(false);
            showSnackbar(
                `Solicitud registrada exitosamente! Ticket #${result.ticketNumber}`,
                "success"
            );
            navigate('/Home');
        } else {
            console.error('Error al crear solicitud:', result.error);
            setOpenModalError(true);
            setResponseError(result.error?.message || 'Error desconocido al crear la solicitud');
            showSnackbar(
                result.error?.message || 'Error al crear la solicitud',
                "error"
            );
        }

        stopLoader();
    }

    useEffect(() => {     
      return () => { 
      }
    }, [])
    

    return (
        <Fragment>
            {SnackbarComponent}
            <div className='modal-confirmation'>
                <div className="modal-confirmation__container">
                    <div className="close" onClick={closeModalConfirm} ></div>
                    <div className="modal-confirmation__body"> 
                        <h2>{infoFrm.Title}</h2>
                        <div>
                            {
                                columnsFrm
                                    .filter(x => x.type !== "thumbnail")
                                    .filter(x => dataFrm[x.name] !== undefined)
                                    .map((item , index) => (
                                        <div key={"id-confirm-frm" + index}>
                                            <div>
                                                <label>{item.displayName}</label>
                                            </div>
                                            <div>
                                                <p>{dataFrm[item.name]}</p>
                                            </div>
                                        </div>
                                    ))
                            }
                            {/* <div>
                                <div>
                                    <label>Aplicativo</label>
                                </div>
                                <div>
                                    <img src={process.env.PUBLIC_URL + '/assets/posint.svg'} alt="" className=''/>
                                </div>
                            </div> 
                            <div>
                                <div>
                                    <label>Archivos Adjuntos</label>
                                </div>
                                <div className='img'>
                                    <div>
                                        <img src={process.env.PUBLIC_URL + '/assets/img-ex.png'} alt="" className=''/>
                                        <span>JPG</span>
                                        <p>Descripción de la imagen que soporta el problema</p>
                                    </div>
                                    <div>
                                        <img src={process.env.PUBLIC_URL + '/assets/img-ex2.png'} alt="" className=''/>
                                        <span>PDF</span>
                                        <p>Descripción de la imagen que soporta el problema</p>
                                    </div>
                                </div>
                            </div>*/}   
                        </div>
                    </div>
                    <div className="modal-confirmation__btn">
                        <button className='cancel' onClick={closeModalConfirm} >Cancelar</button>
                        <button
                            className='confirm'
                            onClick={sendDataConfirm}
                            disabled={!instanceReady || !accounts || accounts.length === 0}
                        >
                            {!instanceReady ? 'Conectando...' : 'Confirmar Solicitud'}
                        </button>
                    </div>
                </div>
            </div>
            <AlertDialogError open={openModalError} setOpen={setOpenModalError} response={responseError} initialData={{
                datosFrm: dataFrm
            }} />
        </Fragment>
    )
}